import { noop } from './noop.mjs';
var warning = noop;
var invariant = noop;
if (process.env.NODE_ENV !== "production") {
  warning = function warning(check, message) {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = function invariant(check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}
export { invariant, warning };